/**
 * @param {object} opts
 * @param {number} opts.total
 * @param {string} opts.label - "automated" | "manual"
 * @param {Array<{ key: string, count: number }>} opts.parts - ordered segments; always rendered (incl. 0)
 */
export function buildTestStatusTooltip({ total, label, parts }) {
  if (!total) return `No ${label} tests in this launch`;
  const body = parts.map(({ key, count }) => `${count} ${key}`).join(', ');
  return `${body} out of ${total} ${label} tests`;
}
